import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import shipment from './shipment'
import operationalSLA from './operationalSLA'
import shipmentUpdate from './shipmentUpdate'
import partner from './partner'
import agent from './agent'
import supplier from './supplier'
import order from './order'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        shipment,
        shipmentUpdate,
        partner,
        agent,
        supplier,
        order,
        operationalSLA,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
